import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=270e4f42"
import script from "./VerifyPhone.vue?vue&type=script&lang=js"
export * from "./VerifyPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports